import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';

/**
 * Componente de tarjeta expandible con animaciones
 * Reemplaza el sistema "Learn more" con una experiencia más fluida
 */
const ExpandableCard = ({ 
  title, 
  subtitle, 
  period, 
  children, 
  initiallyExpanded = false 
}) => {
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded);

  // Variantes para las animaciones de Framer Motion
  const variants = {
    collapsed: { height: 0, opacity: 0 },
    expanded: { height: 'auto', opacity: 1 }
  };

  return (
    <div className="expandable-card bg-background-light rounded-lg p-4 mb-6 shadow-custom transition-all duration-300 hover:shadow-lg">
      <div 
        className="card-header flex justify-between items-start cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="card-title">
          <h3 className="text-xl font-semibold text-accent">{title}</h3>
          {subtitle && <h4 className="text-md text-text-secondary">{subtitle}</h4>}
          {period && <span className="text-sm text-text-secondary block mt-1">{period}</span>}
        </div>
        <motion.button 
          className="expand-button text-accent p-1 rounded-full"
          initial={false}
          animate={{ rotate: isExpanded ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          aria-label={isExpanded ? "Collapse" : "Expand"}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </motion.button>
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            className="card-content mt-4"
            key="content"
            initial="collapsed"
            animate="expanded"
            exit="collapsed"
            variants={variants}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <div className="content-inner border-t border-text-secondary border-opacity-20 pt-4">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

ExpandableCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  period: PropTypes.string,
  children: PropTypes.node.isRequired,
  initiallyExpanded: PropTypes.bool
};

export default ExpandableCard; 